export var DEPLOY_DATE = new Date('2026-03-23T20:50:34+0000');
